import React, {Component} from 'react';
import {Col, Row} from "antd";
import {Link} from "react-router-dom";
import {
    NAVIGATE_CLOSE,
    NAVIGATE_LEVEN2_ENABLE,
    NAVIGATE_OPEN,
} from "../constants";

const menuHeight = "56px";

class Menu extends Component {
    render() {
        //新增动态获取-----------
        let isNewMenu = this.props.config&&this.props.config.getValueByKey?this.props.config.getValueByKey("NewMenu", '1'):'1';
        let defaultColor=this.props.config&&this.props.config.getValueByKey?this.props.config.getValueByKey("NewMenuDefaultColor", 'rgba(255,255,255,.65)'):'rgba(255,255,255,.65)';

        let selectColor=this.props.config&&this.props.config.getValueByKey?this.props.config.getValueByKey("NewMenuSelectColor", 'white'):'white';

        //--------------
        let menu = "";

        switch(isNewMenu) {
            case '0':
                if(this.props.type===1){//一级导航
                    menu = <PrimaryMenu {...this.props}>{React.Children.map(this.props.children, item=>{
                        return item;
                    })}</PrimaryMenu>;
                }else if(this.props.type===2){//二级导航
                    menu = <SecondaryMenu {...this.props}>{React.Children.map(this.props.children, item=>{
                        return item;
                    })}</SecondaryMenu>
                }else{
                    menu = <ThiredMenu  {...this.props}/>
                }
                return menu;
                break;
            case '1':
               // console.log('走新做菜单',this.props.type);
                if(this.props.type===1){//一级导航
                    menu = <NewFirst {...this.props} defaultColor={defaultColor}  selectColor={selectColor} float={this.props.float} isNewMenu={true}>{React.Children.map(this.props.children, item=>{
                        return item;
                    })}</NewFirst>;
                }else if(this.props.type===2){//二级导航
                    menu = <NewSecond {...this.props} defaultColor={defaultColor}  selectColor={selectColor} isNewMenu={true}>{React.Children.map(this.props.children, item=>{
                        return item;
                    })}</NewSecond>
                }else{
                    menu = <NewThird {...this.props} defaultColor={defaultColor}  selectColor={selectColor} isNewMenu={true}/>
                }
                return menu;
                break;
            default:
                if(this.props.type===1){//一级导航
                    menu = <PrimaryMenu {...this.props}>{React.Children.map(this.props.children, item=>{
                        return item;
                    })}</PrimaryMenu>;
                }else if(this.props.type===2){//二级导航
                    menu = <SecondaryMenu {...this.props}>{React.Children.map(this.props.children, item=>{
                        return item;
                    })}</SecondaryMenu>
                }else{
                    menu = <ThiredMenu  {...this.props}/>
                }
                return menu;
                break;
        }
    }
}

class DefaultMenu extends Component{

    type = 0;//节点类型，目前只有1，2，3级导航类型
    me = null;

    changeCheck(){//切换选中状态
        // 清空屏幕左侧二级菜单的滚动条属性 start
        sessionStorage.setItem('navigateLevel2scrollbarsValues', JSON.stringify({}));
        // 清空屏幕左侧二级菜单的滚动条属性 end
        let oldCheck = this.me.check;//原来的选中状态
        if(this.type===0) this.updateMeData();//这块儿做个缓存，免得每次都去遍历
        let data = this.props.navigateData;
        for(let i = 0; data && i <data.length; i++){//跟每一个导航设置一个id，方便进行获取
            let one = data[i];
            if(one.id !== this.props.id){
                if(!one.child || one.child.length===0)one.check=false;//没有子元素的这些元素中，只能有一个被选中
                else if(this.type === 1){
                    one.check=false;
                    one.status="up";
                }//一级导航只能有一个选中,且没选中的要收起来
            }
            for(let j = 0; one.child && j < one.child.length; j++){
                let two = one.child[j];
                if(two.id !== this.props.id){
                    if(this.type === 1){
                        if(!this.me || !this.me.child || this.me.child.length === 0){
                            //如果当前一级导航没有子导航，那么所有的都收起来，且不能被选中
                            two.check=false;
                            two.status="up";
                        }
                    }
                    if(!two.child || two.child.length===0)two.check=false;//没有子元素的这些元素中，只能有一个被选中
                    else if(this.type === 2){
                        two.check=false
                        two.status="up";
                    }//二级导航只能有一个选中，且没选中的要收起来
                }
                for(let k = 0; two.child && k < two.child.length; k++){
                    let three = two.child[k];
                    if(three.id !== this.props.id && (!this.me.child || this.me.child.length===0)){
                        three.check=false;
                    }//没有子元素的这些元素中，只能有一个被选中
                }
            }
        }
        if(!this.me || !this.me.check)
            this.me.check = true;
        let tmp = Object.assign([],this.props.navigateData);//这里需要拷贝，不然不会重绘，


        if(this.type===1){//如果是一级导航，
            if(!this.props.navigateStatus){//如果状态是收缩起来的，
                this.me.check = true;
                this.me.status = "down";
            }
        }

        if(!this.props.children || this.props.children.length === 0){
            // this.props.refersh = oldCheck===this.me.check;
            // this.props.refreshPage(this.props.refersh);
            this.props.refreshPage(oldCheck===this.me.check);
        }
        this.props.updataNavigateData(tmp);
    }

    updateMeData(){//获取当前逻辑对象
        let data = this.props.navigateData;
        for(let i = 0; data && i <data.length; i++){//跟每一个导航设置一个id，方便进行获取
            let one = data[i];
            if(one.id === this.props.id){
                this.type = 1;
                this.me = one;
                return;
            }
            for(let j = 0; one.child && j < one.child.length; j++){
                let two = one.child[j];
                if(two.id === this.props.id){
                    this.type = 2;
                    this.me = two;
                    return;
                }
                for(let k = 0; two.child && k < two.child.length; k++){
                    let three = two.child[k];
                    if(three.id === this.props.id){
                        this.type = 3;
                        this.me = three;
                        return;
                    }
                }
            }
        }
    }

    isChecked(){//判断是否被选中

        if(this.me){
            return this.me.check;
        }
        return false;
    }

    renderContent(){

    }
    showFloatDiv(){

    }

    mouseOver(){}
    mouseOut(){}
    render() {
        let res = this.renderContent();
        if(!this.props.children || this.props.children.length===0){
            if(this.me && this.me.path){
                res = <Link to={this.me.path}>{res}</Link>
            }
        }
        return <div onMouseOver={this.mouseOver.bind(this)} onMouseOut={this.mouseOut.bind(this)}>{res}{this.showFloatDiv()}</div>;
    }
}

class PrimaryMenu extends DefaultMenu{

    bgColor = "#0d62ba";

    changeStatusBySons(e, child, path){
        if(NAVIGATE_LEVEN2_ENABLE){
            if(this.me.float_ &&  this.me.float_.length > 0){
                let menuName = e.target.title;
                this.props.shrinNavigateStauts();
				for(let i = 0 ; i < this.me.float_.length; i++){
					let floatItem = this.me.float_[i];
					floatItem.check = floatItem.path === path;
					floatItem.status = floatItem.check?"down":"up";
				}
                this.checkNodeByPath(child, path);//当网站下面选中了某一个栏目，然后随便切换到一个菜单下然后再切回来，内容页与二级导航选中的地方不匹配
                this.props.updateNavigateLevel2Data(menuName, child);
                window.location.hash = path;//目前只让浮动窗有跳转
            }else{
                if(this.me.child && this.me.child.length > 0){
                    this.props.shrinNavigateStauts();
                }
                this.props.updateNavigateLevel2Data(this.me.menuName, this.me.child);
            }
        }
        if(this.me.status===undefined)
            this.me.status = "up";
        this.me.status = this.me.status==="up"?"down":"up"//展开 or 收起
        this.changeCheck();//切换选中状态
        if(!this.props.navigateStatus && this.props.children && this.props.children.length > 0)
            this.props.changeNavigateStauts();//改变导航状态
    }

    checkNodeByPath(child, path){//根据路径匹配，然后选中对应路径的节点，同时其余节点全都改成未选中
        child && child.map(item => {
            if(item.path  === path){
                item.status = "down";
                item.check = true;
            }else{
                item.status = "up";
                item.check = false;
            }
            if(item.child){
                this.checkNodeByPath(item.child, path)
            };
        })

    }

    changeStatus(e){
        if(NAVIGATE_LEVEN2_ENABLE){
            if(this.me.child && this.me.child.length > 0){
                this.props.shrinNavigateStauts();
            }
            this.props.updateNavigateLevel2Data(this.me.menuName, this.me.child);
        }
        if(this.me.status===undefined)
            this.me.status = "up";
        this.me.status = this.me.status==="up"?"down":"up"//展开 or 收起
        this.changeCheck();//切换选中状态
        if(!this.props.navigateStatus && this.props.children && this.props.children.length > 0)
            this.props.changeNavigateStauts();//改变导航状态
    }

    prevManualNavigateStatusTime = this.props.manualNavigateStatusTime;//上一次手动切换导航的时间

    renderSons(){
        let res = this.isChecked();
        if(NAVIGATE_LEVEN2_ENABLE || this.props.navigateStatus){
            if(this.me && (this.me.status === "down") && res){//如果是展开且是选中状态才显示子元素,且导航是展开状态
                if(NAVIGATE_LEVEN2_ENABLE){//还要渲染二级导航
                    // let name = e.target.title;
                    if(this.me.float_ &&  this.me.float_.length > 0){
                        for(let i = 0 ; i < this.me.float_.length; i++){
                            let floatItem = this.me.float_[i];
                            if(floatItem.status === "down"){
                                if(this.prevManualNavigateStatusTime === this.props.manualNavigateStatusTime){
                                    this.prevManualNavigateStatusTime = this.props.manualNavigateStatusTime;
                                    this.props.shrinNavigateStauts();
                                }
                                this.props.updateNavigateLevel2Data(floatItem.menuName, floatItem.child);
                            }
                        }
                    }else{
                        if(this.me.child && this.me.child.length > 0){
                            if(this.prevManualNavigateStatusTime === this.props.manualNavigateStatusTime){
                                this.prevManualNavigateStatusTime = this.props.manualNavigateStatusTime;
                                this.props.shrinNavigateStauts();
                            }
                            this.props.updateNavigateLevel2Data(this.me.menuName, this.me.child);
                        }
                    }
                }
				//这里是渲染一级导航的二级树
				return React.Children.map(this.props.children, (item, index)=>{
					if(item.props.type === 2){
						return item;
					}
				})
			}

        }

    }

    state = {
        isShowFloatDiv: false
    };
    mouseOver(e){
        this.setState({
            isShowFloatDiv: true
        })
        this.refs.area.style.background = this.bgColor;
    }

    mouseOut(e){
        this.setState({
            isShowFloatDiv: false
        })
        this.refs.area.style.background = this.isChecked()?this.bgColor:"";
    }

    floatDivItemMouseOver(e){
        e.target.backgroundColor = "#0050B3";
    }

    showFloatDiv(){
        let floatDivHeight = this.props.navigateStatus?parseInt(menuHeight):80;//一个的浮窗高度
        let blockWidth = 10;//遮罩块，遮住滚动条，不然浮窗有的时候不灵

        if(this.me.float_ && this.me.float_.length > 0){
            return <div style={{zIndex: "9999",color: "#FFF",display:(this.state.isShowFloatDiv?"block":"none"),position: "fixed",width:"200px",height: (floatDivHeight * this.me.float_.length + "px"),left: (this.props.navigateStatus?(NAVIGATE_OPEN-blockWidth):(NAVIGATE_CLOSE-blockWidth)) + "px",marginTop: "-" + floatDivHeight + "px"}}>
                {
                    this.me.float_.map((item, index) =>
                    <div key={index}>
                        <div style={{float:"left",width:blockWidth+"px",height:floatDivHeight+"px",opacity: "0"}}></div>
                        <div onClick={(e)=>this.changeStatusBychild(e, item.sons, item.path)}
                             title={item.menuName}
                             style={{width:"calc(100% - "+blockWidth+"px)", height:floatDivHeight + "px", lineHeight: floatDivHeight + "px",paddingLeft: "20px",
                                 marginLeft: blockWidth+"px", cursor:"pointer",backgroundColor: "#0d62ba",
                                 overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                            <img alt="系统图标" width="21" src={item.icon} style={{marginBottom: "6px",marginRight: "10px"}} />
                            {item.menuName}
                        </div>
                    </div>)
                }
            </div>
        }
    }


    renderContent() {
        this.updateMeData();
        let that = this;

        let showPrimaryMenuName = "0";
        if(this.props.config){
            showPrimaryMenuName = this.props.config.getValueByKey("show.primary.menu.name", "0");
        }
        return (
            <div ref={"area"} style={{background:(this.isChecked()?this.bgColor:"")}}>
                <Row onClick={()=>{
                    if(!that.me.float_ || that.me.float_.length === 0){
                        that.changeStatus();
                    }
                }}
                     type="flex" style={{cursor:"pointer",paddingLeft:"20px", height:this.props.navigateStatus?menuHeight:"80px"}} justify="space-around" align="middle">
                    <Col span={24} title={this.me.menuName}>
                        {
                            this.props.navigateStatus?<img alt={"系统图标"} width={21} src={this.props.icon} style={{marginBottom:"6px"}} />:
                                <img alt={"系统图标"} src={this.props.icon} style={{marginBottom:"6px"}} width={24} />
                        }
                        {
                            this.props.navigateStatus?<span style={{marginLeft:"10px",fontSize:"16px", color:"#FFF"}}>{this.props.menuName}</span>:(showPrimaryMenuName==="1"?<div style={{marginLeft:"-20px",textAlign:"center",color:"#fff"}}>{this.props.menuName}</div>:"")
                        }
                        {(this.props.navigateStatus && this.props.children && this.props.children.length > 0)?<div style={{float:"right",marginRight:"20px"}}>
                            <img alt={"系统图标"} src={"images/menu/"+((this.me && this.me.status)?this.me.status:"up")+".png"} />
                        </div>:""}
                    </Col>
                </Row>
                {this.renderSons()}
            </div>);
    }
}

class SecondaryMenu extends DefaultMenu{

    state = {
        status: this.props.status,
    };

    bgColor = "#217edf";

    changeStatus(){
        if(this.me.status===undefined)
            this.me.status = "up";
        this.me.status = this.me.status==="up"?"down":"up"//展开 or 收起
        this.changeCheck();//切换选中状态
    }

    renderSons(){
        if(this.me && (this.me.status === "down")){//如果是展开才显示子元素
            return React.Children.map(this.props.children, (item, index)=>{
                if(item.props.type === 3){
                    return item;
                }
            })
        }
    }

    mouseOver(){
        this.refs.area.style.background = this.bgColor;
    }

    mouseOut(){
        this.refs.area.style.background = this.isChecked()?this.bgColor:"";
    }

    renderContent() {
        this.updateMeData();
        return (<div style={{background:"#0f6ac8"}}>
            <div ref={"area"} onMouseOver={this.mouseOver.bind(this)} onMouseOut={this.mouseOut.bind(this)}
                 style={{background:(this.isChecked()?this.bgColor:"")}}>
                <Row type="flex" onClick={this.changeStatus.bind(this)} style={{cursor:"pointer",marginLeft:"50px", height:menuHeight}} justify="space-around" align="middle">
                    <Col span={24}>
                        <span style={{fontSize:"14px", color:"#FFF"}}>{this.props.menuName}</span>
                        {(this.props.children && this.props.children.length > 0)?<div style={{float:"right",marginRight:"20px"}}>
                            <img alt={"系统图标"} src={"images/menu/"+((this.me && this.me.status)?this.me.status:"up")+".png"} />
                        </div>:""}
                    </Col>
                </Row>
            </div>
            {this.renderSons()}
        </div>)
    }
}

SecondaryMenu.defaultProps = {
    status: "up"
}

class ThiredMenu extends DefaultMenu{

    changeStatus(){
        this.changeCheck();
    }

    renderContent() {
        this.updateMeData();
        return (<div>
            <Row onClick={()=>this.changeStatus()} type="flex" style={{cursor:"pointer",marginLeft:"50px", height:menuHeight}} justify="space-around" align="middle">
                <Col span={24}>
                    {this.isChecked() ? <img alt={"系统图标"} src={"images/menu/check.png"} />:
                        <img alt={"系统图标"} src={"images/menu/check.png"} style={{filter:"alpha(opacity:0)", opacity:0}} />}
                    <span style={{marginLeft:"17px", fontSize:"14px", color:"#FFF"}}>{this.props.menuName}</span>
                </Col>
            </Row>
        </div>)
    }
}

//新加的功能类
class NewFirst extends DefaultMenu {
    bgColor = this.props.defaultColor;

    changeStatusBySons(e, child, path) {
        if (NAVIGATE_LEVEN2_ENABLE || this.props.isNewMenu || this.props.isNewMenu) {
            if (this.me.float_ && this.me.float_.length > 0) {
                let menuName = e.target.title;
                this.props.shrinNavigateStauts();
                for (let i = 0; i < this.me.float_.length; i++) {
                    let floatItem = this.me.float_[i];
                    floatItem.check = floatItem.path === path;
                    floatItem.status = floatItem.check ? "down" : "up";
                }
                this.checkNodeByPath(child, path);//当网站下面选中了某一个栏目，然后随便切换到一个菜单下然后再切回来，内容页与二级导航选中的地方不匹配
                this.props.updateNavigateLevel2Data(menuName, child);
                window.location.hash = path;//目前只让浮动窗有跳转
            } else {
                if (this.me.child && this.me.child.length > 0) {
                    this.props.shrinNavigateStauts();
                }
                this.props.updateNavigateLevel2Data(this.me.menuName, this.me.child);
            }
        }
        if (this.me.status === undefined)
            this.me.status = "up";
        this.me.status = this.me.status === "up" ? "down" : "up"//展开 or 收起
        this.changeCheck();//切换选中状态
        if (!this.props.navigateStatus && this.props.children && this.props.children.length > 0)
            this.props.changeNavigateStauts();//改变导航状态
    }

    checkNodeByPath(child, path) {//根据路径匹配，然后选中对应路径的节点，同时其余节点全都改成未选中
        child && child.map(item => {
            if (item.path === path) {
                item.status = "down";
                item.check = true;
            } else {
                item.status = "up";
                item.check = false;
            }
            if (item.child) {
                this.checkNodeByPath(item.child, path)
            }
        })

    }

    changeStatus(e) {
        if (NAVIGATE_LEVEN2_ENABLE || this.props.isNewMenu) {
            if (this.me.child && this.me.child.length > 0) {
                this.props.shrinNavigateStauts();
            }
            this.props.updateNavigateLevel2Data(this.me.menuName, this.me.child);
        }
        if (this.me.status === undefined)
            this.me.status = "up";
        this.me.status = this.me.status === "up" ? "down" : "up"//展开 or 收起
        this.changeCheck();//切换选中状态
        if (!this.props.navigateStatus && this.props.children && this.props.children.length > 0)
            this.props.changeNavigateStauts();//改变导航状态
    }

    prevManualNavigateStatusTime = this.props.manualNavigateStatusTime;//上一次手动切换导航的时间

    renderSons() {
        let res = this.isChecked();
        if (NAVIGATE_LEVEN2_ENABLE || this.props.isNewMenu || this.props.navigateStatus) {
            if (this.me && (this.me.status === "down") && res) {//如果是展开且是选中状态才显示子元素,且导航是展开状态
                if (NAVIGATE_LEVEN2_ENABLE || this.props.isNewMenu) {//还要渲染二级导航
                    // let name = e.target.title;
                    if (this.me.float_ && this.me.float_.length > 0) {
                        for (let i = 0; i < this.me.float_.length; i++) {
                            let floatItem = this.me.float_[i];
                            if (floatItem.status === "down") {
                                if (this.prevManualNavigateStatusTime === this.props.manualNavigateStatusTime) {
                                    this.prevManualNavigateStatusTime = this.props.manualNavigateStatusTime;
                                    window.setTimeout(()=>{
                                        this.props.shrinNavigateStauts();
                                    });
                                }
                                window.setTimeout(()=>{
                                    this.props.updateNavigateLevel2Data(floatItem.menuName, floatItem.child);
                                });
                            }
                        }
                    } else {
                        if (this.me.child && this.me.child.length > 0) {
                            if (this.prevManualNavigateStatusTime === this.props.manualNavigateStatusTime) {
                                this.prevManualNavigateStatusTime = this.props.manualNavigateStatusTime;
                                window.setTimeout(()=>{
                                    this.props.shrinNavigateStauts();
                                });
                            }
                            window.setTimeout(()=>{
                                this.props.updateNavigateLevel2Data(this.me.menuName, this.me.child);
                            });
                        }
                    }
                }
            }
        }
    }

    state = {
        isShowFloatDiv: false
    };

    mouseOver(e) {
    }

    mouseOut(e) {
    }

    floatDivItemMouseOver(e) {
        e.target.backgroundColor = this.props.selectColor;
    }

    showFloatDiv() {
    }

    render() {
        this.updateMeData();
        this.renderSons();
        if(this.props.isMore){
            return <></>;
        }
        let itemWidth=this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("comm.web.header.menu.width", '110') : '110';
        let margin=this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("comm.web.header.menu.margin", '10') : '10';
        itemWidth=parseInt(itemWidth);
        let res = <div style={{position: 'relative',margin:`0 ${margin}px 0 ${margin}px`}} >
                <div style={{
                    color: this.isChecked() ? this.props.selectColor : this.props.defaultColor,
                    fontWeight: this.isChecked() ? 'bold' : null,
                    fontSize: "20px",overflow:'hidden',height:70,lineHeight:"70px"
                }}
                >{this.props.menuName}</div>
                <div style={{
                    height: 2,
                    background: this.isChecked() ? this.props.selectColor : null,
                    position: 'absolute',
                    width: '100%',
                    top: 68
                }}>&nbsp;</div>
            </div>;

        // 在压缩菜单里面
        if(this.props.ellipsis){
            res = <div style={{color: "#333"}}>
                {this.props.menuName}
            </div>
        }

        if (this.me.path) {
            if(/_blank/.test(this.me.jumpType)){
                let path = this.me.path;
                if(!path.startsWith("http")){
                    path = "#"+path;
                }
                return <div className={'firstMenu'} style={{
                    marginTop: this.props.float === 'none' && !this.props.ellipsis? 10 : 0,
                    float: this.props.float,
                    textAlign: 'left',
                    width: (this.props.menuName.length + 1) * 21 - this.props.menuName.split("").filter(item=>/[\da-z]+/ig.test(item)).length * 8,
                    cursor: 'pointer',
                }}><span onClick={()=>{window.open(path);}}>{res}</span></div>
            }else{
                return <div className={'firstMenu'} style={{
                    marginTop: this.props.float === 'none'&& !this.props.ellipsis ? 10 : 0,
                    float: this.props.float,
                    textAlign: 'left',
                    cursor: 'pointer',
                    width: (this.props.menuName.length + 1) * 21 - this.props.menuName.split("").filter(item=>/[\da-z]+/ig.test(item)).length * 8,
                    color:"#000"
                }} onClick={(e) => this.changeStatus(e)}><Link to={this.me.path}>{res}</Link></div>
            }
        } else {
            return <div className={'firstMenu'} style={{
                marginTop: this.props.float === 'none'&& !this.props.ellipsis  ? 10 : 0,
                float: this.props.float,
                textAlign: 'left',
                width: (this.props.menuName.length + 1) * 21 - this.props.menuName.split("").filter(item=>/[\da-z]+/ig.test(item)).length * 8,
                cursor: 'pointer',
            }} onClick={(e) => this.changeStatus(e)} >{res}</div>
        }
    }
}

class NewSecond extends DefaultMenu {

    state = {
        status: this.props.status,
    };

    bgColor = "#217edf";

    changeStatus() {
        if (this.me.status === undefined)
            this.me.status = "up";
        this.me.status = this.me.status === "up" ? "down" : "up"//展开 or 收起
        this.changeCheck();//切换选中状态
    }

    renderSons() {
        if (this.me && (this.me.status === "down")) {//如果是展开才显示子元素
            return React.Children.map(this.props.children, (item, index) => {
                if (item.props.type === 3) {
                    return item;
                }
            })
        }
    }

    mouseOver() {
        this.refs.area.style.background = this.bgColor;
    }

    mouseOut() {
        this.refs.area.style.background = this.isChecked() ? this.bgColor : "";
    }

    renderContent() {
        this.updateMeData();
        return (<div style={{background: "#0f6ac8"}}>
            <div ref={"area"} onMouseOver={this.mouseOver.bind(this)} onMouseOut={this.mouseOut.bind(this)}
                 style={{background: (this.isChecked() ? this.bgColor : "")}}>
                <Row type="flex" onClick={this.changeStatus.bind(this)}
                     style={{cursor: "pointer", marginLeft: "50px", height: menuHeight}} justify="space-around"
                     align="middle">
                    <Col span={24}>
                        <span style={{fontSize: "14px", color: "#FFF"}}>{this.props.menuName}</span>
                        {(this.props.children && this.props.children.length > 0) ?
                            <div style={{float: "right", marginRight: "20px"}}>
                                <img alt={"系统图标"}
                                     src={"images/menu/" + ((this.me && this.me.status) ? this.me.status : "up") + ".png"}/>
                            </div> : ""}
                    </Col>
                </Row>
            </div>
            {this.renderSons()}
        </div>)
    }
}

NewSecond.defaultProps = {
    status: "up"
}

class NewThird extends DefaultMenu {

    changeStatus() {
        this.changeCheck();
    }

    isChecked() {//判断是否被选中

        if (this.props.me) {
            return this.props.me.check;
        }
        return false;
    }

    renderContent() {
        this.updateMeData();
        return (<div>
            <Row onClick={() => this.changeStatus()} type="flex"
                 style={{cursor: "pointer", marginLeft: "50px", height: menuHeight}} justify="space-around"
                 align="middle">
                <Col span={24}>
                    {this.isChecked() ? <img alt={"系统图标"} src={"images/menu/check.png"}/> :
                        <img alt={"系统图标"} src={"images/menu/check.png"}
                             style={{filter: "alpha(opacity:0)", opacity: 0}}/>}
                    <span style={{
                        marginLeft: "17px",
                        fontSize: "14px",
                        color: this.isChecked() ? this.props.selectColor : this.props.defaultColor
                    }}>{this.props.menuName}</span>
                </Col>
            </Row>
        </div>)
    }
}

export default Menu;
